import { ChevronLeft, ChevronRight } from 'lucide-react'
import { cn } from '@/shared/libs/cn'
import { Button } from '@/shared/ui/button'

interface DataTablePaginationProps {
  current: number
  pageSize: number
  total: number
  onChange: (page: number, pageSize: number) => void
}

export function DataTablePagination({
  current,
  pageSize,
  total,
  onChange,
}: DataTablePaginationProps) {
  const pageCount = Math.ceil(total / pageSize)
  const from = total === 0 ? 0 : (current - 1) * pageSize + 1
  const to = Math.min(current * pageSize, total)

  return (
    <div className="flex items-center justify-between border-t border-zinc-200 bg-white px-4 py-3">
      <p className="text-sm text-zinc-500">
        {total > 0 ? `${from}–${to} of ${total}` : 'No results'}
      </p>
      <div className="flex items-center gap-1">
        <Button
          variant="ghost"
          size="icon"
          className={cn('h-8 w-8', current <= 1 && 'opacity-40 cursor-not-allowed')}
          disabled={current <= 1}
          onClick={() => onChange(current - 1, pageSize)}
          aria-label="Previous page"
        >
          <ChevronLeft className="h-4 w-4" />
        </Button>
        <span className="px-2 text-sm text-zinc-700">
          {current} /{pageCount || 1}
        </span>
        <Button
          variant="ghost"
          size="icon"
          className={cn('h-8 w-8', current >= pageCount && 'opacity-40 cursor-not-allowed')}
          disabled={current >= pageCount}
          onClick={() => onChange(current + 1, pageSize)}
          aria-label="Next page"
        >
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  )
}
